import { AuthForm } from "routes/auth/components/AuthForm";

export const ResetPassword: React.FC = () => {
  return <AuthForm mode="reset-password" />;
};
